module.exports = __webpack_public_path__ + "static/media/intl-top-up.05188fa2.png";